<section class="white" *ngIf="pageData">
  <app-banner [pageData]="pageData"></app-banner>

  <div class="content-wrapper" *ngIf="pageData">
    <section class="privacy-page">
      <h1 *ngIf="pageData.title">{{ pageData.title }}</h1>
      <div class="privacy-policies-container" *ngIf="pageData.policies">
        <div class="privacy-policy" *ngFor="let policy of pageData.policies">
          <h5 class="policy-heading" (click)="togglePrivacyPolicy($event)">
            {{ policy.policy_title }}
          </h5>
          <span class="pp-toggle"></span>
          <div class="privacy-policy-content">
            <app-render-markdown
              [content]="policy.policy_content!"
            ></app-render-markdown>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>
